export const STATSIG_SEARCH_LAYER = 'search_page_experiments';

export const STATSIG_SERVER_BOOTSTRAP_CLIENT_KEY =
    'client-3IATYuZKoGUhjVATWSSMKTI63CaGjqEzivgV4OiNsSe';
